module.exports = __webpack_public_path__ + "static/media/arrow-left-darkgrey.e4589aee.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/arrow-left-darkgrey.svg
// module id = 894
// module chunks = 0